export default "__VITE_ASSET__CQ1xuiE$__"